import ElInput from './src/input';
import '@/theme/css/basic/input.scss';

/* istanbul ignore next */
// ElInput.install = function(Vue) {
//   Vue.component(ElInput.name, ElInput);
// };

export default ElInput;